module.exports = __webpack_public_path__ + "img/cn.b06a0b92.png";